import { LogReporter } from '@/common/log-report';
import { createExposeMeta } from '@/directives/expose';

// https://info.bilibili.co/pages/viewpage.action?pageId=514170829
export const enum EventName {
  GiftBarShow = 'gift_bar_show', // 礼物栏礼物详情面板 曝光
  GiftBarSendClick = 'gift_bar_send_click', // 礼物栏礼物详情面板SEND按钮点击
  FollowClick = 'follow_click', // 关注按钮点击
  AnchorNicknameClick = 'anchor_nickname_click', // 主播昵称点击
  AnchorIconClick = 'anchor_icon_click', // 主播头像点击
  GiftDashboardExpandClick = 'gift_dashboard_expand_click', // 全部礼物面板展开按钮点击
  RechargeClick = 'recharge_click', // 充值按钮点击
  ShareClick = 'share_click', // Share按钮点击
  AllGiftDashboardShow = 'allGift_dashboard_show', // 全部礼物面板曝光
  RechargeDashboardShow = 'recharge_dashboard_show', // 充值面板曝光
  RechargeDashboardClick = 'recharge_dashboard_click', // 充值面板按钮点击
  RechargeIncompletePopupShow = 'recharge_incomplete_popup_show', // 充值未完成弹窗曝光	
  RechargeIncompletePopupClick = 'recharge_incomplete_popup_click', // 充值未完成弹窗按钮点击
}

export const enum RechargeDashboardClickPos {
  Next = 'next',
  Agreement = 'agreement'
}

export const enum RechargeIncompletePopupClickPos {
  GetPaid = 'get_paid',
  Repay = 'repay',
  Close = 'close'
}

export const roomTracker = {
  getGiftBarShowMeta(gift_id: number) {
    return createExposeMeta(EventName.GiftBarShow, `${gift_id}`, { gift_id });
  },

  GiftBarSendClick(gift_id: number) {
    return LogReporter.sendClick({ event: EventName.GiftBarSendClick, value: { gift_id } });
  },

  FollowClick(room_id: number, ruid: number) {
    return LogReporter.sendClick({ event: EventName.FollowClick, value: { room_id, ruid } });
  },

  AnchorNicknameClick(room_id: number, ruid: number) {
    return LogReporter.sendClick({ event: EventName.AnchorNicknameClick, value: { room_id, ruid } });
  },

  AnchorIconClick(room_id: number, ruid: number) {
    return LogReporter.sendClick({ event: EventName.AnchorIconClick, value: { room_id, ruid } });
  },

  GiftDashboardExpandClick(room_id: number) {
    return LogReporter.sendClick({ event: EventName.GiftDashboardExpandClick, value: { room_id } });
  },

  RechargeClick(room_id: number) {
    return LogReporter.sendClick({ event: EventName.RechargeClick, value: { room_id } });
  },

  ShareClick(room_id: number) {
    LogReporter.sendClick({ event: EventName.ShareClick, value: { room_id } });
  },

  getAllGiftDashboardShowMeta(room_id: number) {
    return createExposeMeta(EventName.AllGiftDashboardShow, '', { room_id });
  },

  getRechargeDashboardShowMeta(room_id: number) {
    return createExposeMeta(EventName.RechargeDashboardShow, '', { room_id });
  },

  RechargeDashboardClick(room_id: number, stars: number, pos: RechargeDashboardClickPos) {
    LogReporter.sendClick({ event: EventName.RechargeDashboardClick, value: { room_id, stars, pos } });
  },

  getRechargeIncompletePopupShowMeta(room_id: number, order_no: string) {
    return createExposeMeta(EventName.RechargeIncompletePopupShow, '', { room_id, order_no });
  },

  RechargeIncompletePopupClick(room_id: number, order_no: string, pos: RechargeIncompletePopupClickPos) {
    LogReporter.sendClick({ event: EventName.RechargeIncompletePopupClick, value: { room_id, order_no, pos } });
  },
};